module.exports = __webpack_public_path__ + "img/icon-instagram.33f7c189.svg";